import { useCallback, useEffect, useRef } from "react"

export const DEFAULT_VOLUME = 1

export function usePlayerVolumeMute(
  volume: number,
  onVolumeChange: (volume: number) => void
) {
  const prevVolumeRef = useRef(volume > 0 ? volume : DEFAULT_VOLUME)

  const toggleMute = useCallback(() => {
    if (volume === 0) {
      onVolumeChange(
        prevVolumeRef.current > 0 ? prevVolumeRef.current : DEFAULT_VOLUME
      )
      return
    }
    prevVolumeRef.current = volume
    onVolumeChange(0)
  }, [onVolumeChange, volume])

  useEffect(() => {
    if (volume > 0) {
      prevVolumeRef.current = volume
    }
  }, [volume])

  return { toggleMute, isMuted: volume === 0 }
}
